import { ClipboardList, ChefHat, Truck } from "lucide-react";
import { howItWorks } from "../mock";

const iconMap = { ClipboardList, ChefHat, Truck };

export default function HowItWorks() {
  return (
    <div className="mt-10 grid gap-6 md:grid-cols-3">
      {howItWorks.map((s, i) => {
        const Icon = iconMap[s.icon] || ClipboardList;
        return (
          <div
            key={s.title}
            className="relative rounded-2xl border border-neutral-200 bg-white p-7 hover:border-green-600 hover:shadow-md transition-all"
          >
            <div className="absolute -top-4 left-6 w-9 h-9 rounded-full bg-green-600 text-white text-sm font-bold flex items-center justify-center">
              {i + 1}
            </div>
            <div className="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center text-green-700">
              <Icon size={22} />
            </div>
            <h3 className="mt-4 text-lg font-bold text-neutral-900">{s.title}</h3>
            <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
          </div>
        );
      })}
    </div>
  );
}
